import styled from "styled-components";
import {
  HeroBanner,
  NftAboutBg,
} from "../../shared/icons";
import { screenSizes } from "../../styles/theme";

//CTA section get latest insights
export const CtaSectionWrapper = styled.div`
  background: #1e440b;
  padding: 3rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 40px 0;
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 1.5rem;
  }
`;
export const CtaSectionContent = styled.div`
  h2 {
    color: #ffffff;
    span {
      color: #ff9d59;
    }
  }
`;
export const CtaSectionForm = styled.div`
  div {
    display: flex;
    gap: 20px;
    align-items: center;

    input {
      background: #ffffff;
      padding: 15px 10px;
      border: none;
      max-width: 400px;
      font-family: "Sora", sans-serif;
    }
  }
  p {
    max-width: 500px;
    color: #ffffff;
    font-family: "Sora", sans-serif;
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

//CTA section get latest insights

// Hero section get latest

export const HeroBannerSection = styled.div`
  margin-bottom: 40px;
  .swiper {
    background: url(${HeroBanner}) no-repeat center center;
    height: 100vh;
    background-size: cover;
    padding: 50px 0;
    .swiper-button-prev,
    .swiper-button-next {
      background: #fff;
      border-radius: 50px;
      width: 44px;
      box-shadow: 0 2px 6px 0 #00000038;
      @media (max-width: ${screenSizes.S}px) {
        display: none;
      }
      &:after,
      &:after {
        font-size: 14px;
        color: #1e440b;
        font-weight: bold;
      }
    }
    .swiper-pagination-bullet {
      border-radius: 0px;
      width: 60px;
      height: 5px;
    }
    .swiper-pagination-bullet-active {
      background: #fff;
    }
  }
  .swiper-slide {
    ul {
      list-style-type: none;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      @media (max-width: ${screenSizes.S}px) {
        grid-template-columns: repeat(1, 1fr);
      }
      align-items: center;
      padding: 0;
      margin: 0;
      li {
        h1 {
          font-weight: 400;
          font-size: calc(2.1vw + 20px);
          color: #fff;
        }
        p {
          font-family: "Sora", sans-serif;
          font-weight: 400;
          color: #fff;
          line-height: 150%;
          span {
            position: relative;
            padding-left: 15px;
            font-family: "Sora", sans-serif;
            &:before {
              content: "";
              position: absolute;
              left: 0;
              top: 5px;
              background: #fff;
              width: 8px;
              height: 8px;
              border-radius: 50px;
            }
          }
        }
      }
    }
  }
`;

//Listing Card section
export const CardListingWrapper = styled.div`
  padding: 15px;
  border: 1px solid #eaeaea;
`;
export const CardListingHeader = styled.div`
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    h4 {
      color: #1e440b;
    }
    div {
      background: #f5f5f5;
      padding: 10px 15px;
      border-radius: 50px;
      dispaly: flex;
      column-gap: 10px;
      cursor: pointer;
      img {
      }
      span {
        font-family: "Sora", sans-serif;
        color: #1e440b;
      }
    }
  }
  a {
    font-family: "Sora", sans-serif;
    color: #1e440b;
    display: inline-block;
    background: #f5f5f5;
    padding: 10px 15px;
    border-radius: 50px;
    img {
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  border-bottom: 1px solid #eaeaea;
`;

//Cards
export const ParentCardsBox = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  @media (max-width: ${screenSizes.L}px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: ${screenSizes.M}px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const CardWrapper = styled.div`
  cursor: pointer;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
  img {
    height: 230px;
    width: 100%;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  h6 {
    margin: 5px 0px 10px;
    font-size: 15px;
    font-weight: 400;
    color: #1e440b;
  }
  .card-headings {
    color: #737376;
    font-size: 12px;
    padding-bottom: 5px;
  }
  p {
    color: #1e440b;
    margin: 0;
  }
`;
export const CardStatusBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f6f6f6;
  border-radius: 10px;
  padding: 10px;
`;

//Cards end

export const ViewAllCard = styled.div`
  text-align: center;
  padding: 20px 0 5px;
`;

export const MiddleSecWrapper = styled.div`
  border: 1px solid #eaeaea;
  position: relative;
  padding: 0;
  background: #f2e5c0;
  @media (max-width: ${screenSizes.S}px) {
    margin: 30px 0;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: ${screenSizes.S}px) {
      grid-template-columns: repeat(1, 1fr);
    }
    align-items: center;
    list-style: none;
    gap: 0px;
    padding: 0;
    margin: 0;

    li {
      button {
        margin-top: 15px;
      }
      .subtitle {
        background-color: #091C0033;
      }
      h1 {
        font-weight: 300;
        font-size: calc(4rem + 20px);
        color: #fff;
        margin-bottom: 20px;
        line-height: 130%;
        span {
          font-weight: 700;
          @media (max-width: ${screenSizes.M}px) {
          font-size: 64px;
          letter-spacing: -4px;
        }
        }
        @media (max-width: ${screenSizes.M}px) {
          letter-spacing: -4px;
          font-size: 60px;
        }
      }
      p {
        font-family: "Sora", sans-serif;
        font-weight: 400;
        color: #fff;
        margin-top: 0;
        line-height: 150%;
        span {
          position: relative;
          padding-left: 15px;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 5px;
            background: #fff;
            width: 8px;
            height: 8px;
            border-radius: 50px;
          }
        }
      }
      &:first-child {
        background: url(${NftAboutBg}) no-repeat center center !important;
        background-size: cover !important;
        padding: 5rem 6rem !important;
        @media (max-width: ${screenSizes.L}px) {
          padding: 5rem 1rem !important;
        }
        @media (max-width: ${screenSizes.S}px) {
          padding: 6rem 1rem !important;
        }
      }
      &:last-child {
        text-align: center;
        background: #f1e5c0 !important;
        padding: 3.5rem 6rem !important;
        @media (max-width: ${screenSizes.M}px) {
          padding: 1rem !important;
        }
        h2 {
          text-align: left;
          font-size: calc(2rem + 16px);
          color: #091c00;
          padding-bottom: 50px;
          @media (max-width: ${screenSizes.S}px) {
          font-size: 40px;
          padding-bottom: 10px;
        }
        }
      }
    }
    p {
      span {
        position: relative;
        padding-left: 10px;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 7px;
          border-radius: 50px;
          width: 5px;
          height: 5px;
          background: #000;
        }
      }
    }
  }
  .sticker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 160px;
  background-color: #FF9D59;
  border-radius: 50%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  cursor: pointer;
  &:hover {
    background-color: #E0772D;
  }
}
`;
export const PortFolioWapper = styled.div`
  padding: 2rem 4rem;
  @media (max-width: ${screenSizes.M}px) {
    padding: 0rem 1rem;
  }
  ul {
  @media (max-width: ${screenSizes.M}px) {
    display: block;
  }
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    li {
      padding: 30px;
      border: 1px solid #091c001a;
      position: relative;
      height: calc(100% - 20px);
      margin-bottom: 30px;
      @media (max-width: ${screenSizes.M}px) {
        padding: 15px;
      }
      a {
        position: absolute;
        bottom: 20px;
        color: #091c00;
        transform: 0.3s;
        font-weight: 600;
        &:hover {
          color: #ff9d59;
          .svg-hover {
              filter: invert(75%) sepia(60%) saturate(487%) hue-rotate(-10deg) brightness(100%) contrast(92%);
            }
        }
        img {
          vertical-align: middle;
          margin-left: 10px;
        }
      }
      h3 {
        font-weight: 700;
        margin-top: 20px;
        @media (max-width: ${screenSizes.M}px) {
        margin-top: 10px;
        font-size: 24px;
      }
      }
      p {
        font-size: 18px;
        color: #091c00b2;
        line-height: 30px;
        margin-bottom: 65px;
        @media (max-width: ${screenSizes.M}px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
      &:first-child {
        background: #ff9d59;
        color: #fff;
        border-radius: 0 0px 0px 30px;
        img {
          border-radius: 50%;
        }
        p {
          color: #fff;
        }
      }
      @media (max-width: ${screenSizes.L}px) {
        border-radius: 0 0px 0px 30px;
        p {
        margin-bottom: 40px;
        }
      }
    }
  }
`;

export const PortfolioTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #091c001a;
  padding-bottom: 20px;
  margin-bottom: 30px;
  h5 {
    font-size: 16px;
    margin: 0;
    img {
      vertical-align: middle;
      margin-left: 10px;
    }
  }
`;
